import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { SelectorOption } from '../interfaces/form-and-field.interface';
import { AppPreloadingService } from './app-preloading.service';

export function configureAppData(service: AppPreloadingService): () => Promise<SelectorOption[][]> {
  return () => service.configureStaticAppData();
}

/**
 * @description App Preloading module is responsible for an app data configuration at it startup.
 *   1. Generally, APP_INITIALIZER ia a DI token that you can use to provide one or more
 *      initialization functions that injected at application startup and executed during
 *      app initialization. If any of these functions returns a Promise, initialization
 *      does not complete until the Promise is resolved.
 *   2. In our case, this module is used for setting up the translations of suggestions
 *      hints at application startup depend on selected language. So the configureAppData()
 *      function is executed during the application bootstrap process, and the needed
 *      translations are available on startup. This helps to initialize options of
 *      the appropriate form constructor field with non-empty suggestions.
 */
@NgModule({
  imports: [HttpClientModule],
  providers: [
    AppPreloadingService,
    {
      provide: APP_INITIALIZER,
      useFactory: configureAppData,
      deps: [AppPreloadingService],
      multi: true,
    },
  ],
})
export class AppPreloadingModule {}
